import { Page } from '@/components/dashboard/page';
import { Form, resolver, TextField } from 'ht-sdk/react/forms';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button, Col, Heading } from 'ht-sdk/react';
import { useForm } from 'react-hook-form';
import { api } from '@/api';
import { LocationCreateSchema } from '@shared/modelTypes/location-types';
import { toast } from 'sonner';

export const Route = createFileRoute('/dashboard/locations/new')({
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = useNavigate();

	const form = useForm({
		resolver: resolver(LocationCreateSchema),
	});
	const errors = form.formState.errors;
	console.log('all the errors', errors);

	return (
		<Page>
			<Heading>New Location</Heading>
			<Form
				methods={form}
				onSubmit={async (data) => {
					console.log('onSubmit', data);

					const res = await api.locationCreate(data);
					if (!res.success) {
						toast.error(res.message);
						return;
					} else {
						toast.success('Location created successfully');
						navigate({ to: '/dashboard/locations' });
					}
				}}
				onInvalid={(errors) => {
					console.log('got errors', errors);
				}}
			>
				<Col gap={3}>
					<TextField name="name" label="Name" placeholder="Name" />
					<TextField name="code" label="Code" placeholder="Code" className="font-mono uppercase" />
					<Button type="submit" className="cursor-pointer">
						Create
					</Button>
				</Col>
			</Form>
		</Page>
	);
}
